module.exports = __webpack_public_path__ + "fonts/Golos-Text_Black.ac573a4.ttf";